"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Popover_1 = tslib_1.__importDefault(require("@mui/material/Popover"));
const PopoverErrorBoundary_1 = tslib_1.__importDefault(require("./PopoverErrorBoundary"));
const StyledButton_1 = tslib_1.__importDefault(require("./StyledButton"));
const ButtonWithPopover = (props) => {
    const { ButtonProps, onRenderError, arrowOffset, ...popoverProps } = props;
    const buttonRef = (0, react_1.useRef)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledButton_1.default, { ref: buttonRef, ...ButtonProps }),
        react_1.default.createElement(Popover_1.default, { anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            }, transitionDuration: 0, slotProps: {
                paper: {
                    sx: (theme) => ({
                        overflow: "visible",
                        mt: 0.5,
                        p: 1.5,
                        "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            left: arrowOffset,
                            width: 15,
                            height: 15,
                            backgroundColor: "inherit",
                            transform: "translateY(-50%) rotate(45deg)",
                            boxShadow: "-3px -3px 5px -2px rgba(0,0,0,0.1)",
                            borderRadius: "4px 0 0 0",
                            ...theme.applyStyles("dark", {
                                // mui uses backgroundImage in dark mode for the paper elevation. This is based on the css from paper in dark mode.
                                backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12))",
                            }),
                        },
                    }),
                },
            }, ...popoverProps, children: react_1.default.createElement(PopoverErrorBoundary_1.default, { onRenderError: onRenderError }, popoverProps?.children) })));
};
exports.default = ButtonWithPopover;
